import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

const KEY = "fluo_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, size, quantity = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex(
        (i) => i.product_id === product.id && i.size === size
      );
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + quantity };
        return next;
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          size,
          quantity,
          unit_price: product.price_chf,
          photo: product.photos?.[0] || null,
        },
      ];
    });
  };

  const updateQty = (product_id, size, quantity) => {
    setItems((prev) =>
      prev
        .map((i) =>
          i.product_id === product_id && i.size === size
            ? { ...i, quantity: Math.max(1, quantity) }
            : i
        )
    );
  };

  const removeItem = (product_id, size) => {
    setItems((prev) =>
      prev.filter((i) => !(i.product_id === product_id && i.size === size))
    );
  };

  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.unit_price * i.quantity, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, updateQty, removeItem, clear, count, subtotal }}
    >
      {children}
    </CartContext.Provider>
  );
}
